// Trading Dashboard Title Component
export default {
  // Titles
  tradingDashboard: "Trading Dashboard",
  updated: "Updated",

  // Tooltip
  delayTooltip:
    "When an address is first added to the trading dashboard, data may be delayed up to 1 hour. Please be patient.",

  // Placeholders and Labels
  selectCurrency: "Select Currency",
  allBlockchains: "All",
};
